import { render, staticRenderFns } from "./Counter.vue?vue&type=template&id=bd53e194&scoped=true&lang=pug&"
import script from "./Counter.vue?vue&type=script&lang=ts&"
export * from "./Counter.vue?vue&type=script&lang=ts&"
import style0 from "./Counter.vue?vue&type=style&index=0&id=bd53e194&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd53e194",
  null
  
)

export default component.exports